import React from "react"
import { Accept } from "react-dropzone"

import { ApiResponse } from "shared/types/ApiResponse"
import { FilePreview } from "shared/types/File"
import { AttachmentType } from "shared/types/__generated__/graphql"
import { FileCardProps } from "shared/ui/file-card/FileCard"

export interface FileUploadPropsContextType<Multiple extends boolean> {
  files?:
    | (Multiple extends true ? AttachmentType[] : AttachmentType)
    | null
    | undefined
  isReadonly?: boolean
  isDisabled?: boolean
  isLoading?: boolean
  loadingFileCount?: number
  target?: React.AnchorHTMLAttributes<HTMLAnchorElement>["target"]
  dataFormats?: string[]
  showUploading?: boolean
  multiple?: Multiple
  label?: string
  required?: boolean
  accept?: Accept
  inputId: string
  onUpload?: (file: FilePreview) => Promise<ApiResponse<unknown>> | void
  onUploadComplete?: (
    successes: FilePreview[],
    failures: FilePreview[]
  ) => Promise<unknown> | void
  onDelete?: (file: AttachmentType) => Promise<unknown> | void
  onReplace?: (file: AttachmentType) => Promise<unknown> | void
  FileCardComponent?: React.ComponentType<
    FileCardProps & { attachment?: AttachmentType }
  >
}

export const FileUploadPropsContext = React.createContext<
  FileUploadPropsContextType<true> | FileUploadPropsContextType<false>
>({
  files: undefined,
  inputId: ""
})

interface FileUploadPropsProviderProps<Multiple extends boolean>
  extends FileUploadPropsContextType<Multiple> {
  children: React.ReactNode
}

export function FileUploadPropsProvider<Multiple extends boolean>({
  children,
  ...props
}: FileUploadPropsProviderProps<Multiple>) {
  return (
    <FileUploadPropsContext.Provider
      value={
        props as
          | FileUploadPropsContextType<true>
          | FileUploadPropsContextType<false>
      }
    >
      {children}
    </FileUploadPropsContext.Provider>
  )
}
